import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  wrap: {
    overflow: 'auto',
  },
  root: {
    minHeight: theme.spacing(7),
  },
  icon: {
    color: theme.palette.grey[200],
    '.MuiListItem-button &': {
      color: theme.palette.primary.main,
    },
  },
  textWrapper: {
    display: 'flex',
    flexDirection: 'column-reverse',
  },
  primary: {
    wordBreak: 'break-word',
    color: theme.palette.grey[300],
    '.MuiListItem-button &': {
      color: theme.palette.primary.main,
      fontWeight: 600,
    },
  },
  secondary: {
    color: theme.palette.grey[200],
  },
}))

export default useStyles
